"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoutes = exports.getUrlWithCombinedQueryParam = exports.getUrlWithReplacedPathParam = void 0;
const beta_1 = require("./beta");
const beta1_1 = require("./beta1");
const development_1 = require("./development");
const production_1 = require("./production");
const qa_1 = require("./qa");
const qa_pr_1 = require("./qa-pr");
const stage_1 = require("./stage");
const getUrlWithReplacedPathParam = (url, params) => {
    return Object.keys(params).reduce((prev, key) => {
        return prev.replace(`:${key}`, params[key]);
    }, url);
};
exports.getUrlWithReplacedPathParam = getUrlWithReplacedPathParam;
const getUrlWithCombinedQueryParam = (url, query) => {
    const QUERY_STRING_START_CHAR = '?';
    const [originPath, queryString] = url.split(QUERY_STRING_START_CHAR);
    const originalQueryParam = Object.fromEntries(new URLSearchParams(queryString));
    const queryParam = {
        ...originalQueryParam,
        ...(typeof window !== 'undefined' && getKeepQueryParam()),
        ...query,
    };
    const searchParams = new URLSearchParams(queryParam);
    const searchParamKeyValueList = Array.from(searchParams.entries());
    for (const [key, value] of searchParamKeyValueList) {
        if (isEmptyString(value))
            searchParams.delete(key);
    }
    return isEmptyString(searchParams.toString())
        ? originPath
        : `${originPath}${QUERY_STRING_START_CHAR}${searchParams.toString()}`;
};
exports.getUrlWithCombinedQueryParam = getUrlWithCombinedQueryParam;
const isEmptyString = (str) => !str || str === '';
const getKeepQueryParam = () => {
    const KEEP_QUERY_PARAM_KEYS = ['from'];
    const currentQueryParam = Object.fromEntries(new URLSearchParams(location.search));
    return Object.fromEntries(Object.keys(currentQueryParam)
        .filter(key => KEEP_QUERY_PARAM_KEYS.includes(key))
        .map(key => [key, currentQueryParam[key]]));
};
const getRoutes = (PHASE) => {
    var _a;
    if (!['production', 'stage', 'beta', 'beta1', 'qa', 'development'].includes(PHASE))
        return production_1.productionLinks;
    if (PHASE === 'qa' && process.env.PR_NUMBER) {
        return (0, qa_pr_1.getQaPrLink)();
    }
    return ((_a = {
        development: development_1.developmentLinks,
        qa: qa_1.qaLinks,
        beta: beta_1.betaLinks,
        beta1: beta1_1.beta1Links,
        stage: stage_1.stageLinks,
        production: production_1.productionLinks,
    }[PHASE]) !== null && _a !== void 0 ? _a : production_1.productionLinks);
};
exports.getRoutes = getRoutes;
